import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-crosstalk-custom-checkbox',
    templateUrl: './crosstalk-custom-checkbox.component.html',
    styleUrls: ['./crosstalk-custom-checkbox.component.scss'],
    standalone: false,
})
export class CrosstalkCustomCheckboxComponent implements ICellRendererAngularComp {
    value: boolean | undefined;
    renderCheckbox: boolean | undefined;
    private params: ICellRendererParams | undefined;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.value = this.params.node.isSelected();
        this.renderCheckbox = !this.params.node.group && Object.keys(this.params.node.data).length > 0;
    }

    refresh(): boolean {
        this.value = this.params?.node.isSelected();
        return true;
    }

    onClick(value: boolean): void {
        this.params?.node.setSelected(value);
        this.params?.api.refreshHeader();
    }
}
